import { RunSchema } from '../../../types/schema';

function MetadataKVPair(props: { metadataKey: string; metadataValue: string }) {
  return (
    <div className="whitespace-nowrap rounded-md border border-slate-300 px-1 py-0.5 text-xs dark:border-slate-700">
      {props.metadataKey}: {props.metadataValue}
    </div>
  );
}

export function MetadataKeyValuePairs({ run }: { run?: RunSchema | null }) {
  const metadataKVPairs = run?.extra?.metadata
    ? Object.entries(run.extra.metadata)
    : [];

  const children = metadataKVPairs?.map?.(([k, v]) => (
    <MetadataKVPair
      key={k}
      metadataKey={k}
      metadataValue={typeof v === 'string' ? v : JSON.stringify(v)}
    />
  ));

  return metadataKVPairs?.length ? <>{children}</> : null;
}
